import {Box, Button, Modal, Typography} from '@mui/material';
import React, {useCallback} from 'react';
import styles from '../../styles';
import {useTranslation} from 'react-i18next';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const ModifyShopifySubscriptionModal: React.FC<Props> = ({open, setOpen}) => {
  const {t} = useTranslation();

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={styles.modal}>
        <Typography variant="h4" sx={{mb: 2}}>
          {t('membership.selectPlan')}
        </Typography>
        <Typography variant="body1" sx={{mb: 2}}>
          {t('membership.modifyShopifySubscriptionInstructions')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            {t('general.close')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModifyShopifySubscriptionModal;
